import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes reaccionaba mal en todo… ahora sé frenar y pensar.',
  name: 'Martina G.',
  role: 'Buenos Aires'
}, {
  quote: 'Me ayudó a entender lo que siento y no explotar por todo.',
  name: 'Nicolás P.',
  role: 'Córdoba'
}, {
  quote: 'Dejé de sentirme desbordada todo el tiempo.',
  name: 'Valeria S.',
  role: 'Rosario'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-266">
      <div className="max-w-xl mx-auto" data-id="element-267">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-268">
          💬 ¿Qué dicen quienes ya usan el Mega Pack?
        </h2>

        <div className="space-y-4" data-id="element-269">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-5 rounded-xl" data-id="element-270">
              <div className="flex gap-0.5 mb-3" data-id="element-271">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-272" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-273">
                "{t.quote}"
              </p>
              <div data-id="element-274">
                <p className="font-bold text-white text-sm" data-id="element-275">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-276">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}